import React, { useState } from 'react';
import Pagination from './Pagination';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, ShoppingBag, ExternalLink, CheckCircle } from 'lucide-react';
import './Shop.css';

// Import product images
import makoCricketBat from '../Images/Mako Cricket Bat.jpeg';
import makoCricketBatJr from '../Images/Mako Cricket Bat Junior.jpeg';
import makoBattingGloves from '../Images/Mako Batting Gloves.jpeg';
import makoHockeySticks from '../Images/Mako Hockey Sticks.jpeg';
import makoCricketSatchel from '../Images/Mako Cricket Satchel.jpeg';
// Removed unused boxingGlove and assortedJerseys imports

// Newly imported images
import makoBattingPads from '../Images/mako betting pad.jpeg';
import makoThighPads from '../Images/mako thigh pads.jpeg';
import cricketElbowGuard from '../Images/elbow guard.jpeg';
import cricketBoxer from '../Images/cricket boxer.jpeg';
import woodenHockeyStick from '../Images/wooden hockey stick.jpeg';
import hockeyShinPads from '../Images/hockey shin ads.jpeg';
import soccerShinPads from '../Images/soccer shin pads.jpeg';
import makoSoccerBall from '../Images/mako soccer balls.jpeg';
import boxingMitts from '../Images/boxing mits.jpeg';
import boxingGloves from '../Images/boxing gloves.jpeg';
import gymLeatherGloves from '../Images/gym leather gloves.jpeg';
import gymLeatherBelt from '../Images/leather gym belt.jpeg';
import gymNeopreneBelt from '../Images/neproene gym belt.jpeg';
import backPainHelper from '../Images/back pain helper.jpeg';
import gymnasticBall from '../Images/gymnastic ball.jpeg';
import suctionSitUp from '../Images/sunction sit up.jpeg';
import springExerciser from '../Images/spring exciser.jpeg';
import compressionVest from '../Images/compression vest.jpeg';
import hipBands from '../Images/hip bands.jpeg';
import resistanceBands from '../Images/resistance bands.jpeg';
import swimmingGoggles from '../Images/swimming goggles.jpeg';
import swimmingCapsGoggles from '../Images/swimming caps & goggles.jpeg';
import wristSandBags from '../Images/o.2kg wrist sandbag.jpeg';
import sandBags05kg from '../Images/0,5kg sandbags.jpeg';
import kinesiologyTape from '../Images/kinesiology tap.jpeg';
import assortedFootballJerseys from '../Images/assorted football jersery.jpeg';


const products = [
    // Mako Club Cricket Equipment
    { id: 1, name: 'Mako Club Cricket Bat', category: 'Cricket', price: 65, image: makoCricketBat, featured: true },
    { id: 2, name: 'Mako Club Cricket Bat Junior', category: 'Cricket', price: 55, image: makoCricketBatJr },
    { id: 3, name: 'Mako Club Batting Gloves', category: 'Cricket', price: 23, image: makoBattingGloves },
    { id: 4, name: 'Mako Cricket Batting Pads', category: 'Cricket', price: 50, image: makoBattingPads },
    { id: 5, name: 'Mako Cricket Batting Pads Junior', category: 'Cricket', price: 45, image: makoBattingPads },
    { id: 6, name: 'Mako Cricket Thigh Pads', category: 'Cricket', price: 18, image: makoThighPads },
    { id: 7, name: 'Mako Club Keeper Pads', category: 'Cricket', price: 43, image: makoBattingPads }, // Assuming similar pads for now if no specific keeper image
    { id: 8, name: 'Mako Cricket Satchel', category: 'Cricket', price: 65, image: makoCricketSatchel, featured: true },

    // Cricket Gear
    { id: 9, name: 'Cricket Elbow Guard', category: 'Cricket', price: 18, image: cricketElbowGuard },
    { id: 10, name: 'Cricket Boxer', category: 'Cricket', price: 5, image: cricketBoxer },
    { id: 11, name: 'Cricket Pads', category: 'Cricket', price: 10, image: makoBattingPads }, // Using batting pads image as generic

    // Hockey Equipment
    { id: 12, name: 'Mako Wooden Hockey Stick Junior', category: 'Hockey', price: 18, image: makoHockeySticks },
    { id: 13, name: 'Mako Wooden Hockey Stick Medium', category: 'Hockey', price: 20, image: makoHockeySticks },
    { id: 14, name: 'Mako Wooden Hockey Stick', category: 'Hockey', price: 30, image: woodenHockeyStick, featured: true },
    { id: 15, name: 'Mako Hockey Stick (Composite)', category: 'Hockey', price: 65, image: makoHockeySticks },
    { id: 16, name: 'Mako Hockey Shin Pads', category: 'Hockey', price: 25, image: hockeyShinPads },

    // Soccer Gear
    { id: 17, name: 'Mako Soccer Shin Guards', category: 'Soccer', price: 18.5, image: soccerShinPads },
    { id: 18, name: 'Mako Soccer Balls', category: 'Soccer', price: 30, image: makoSoccerBall },

    // Boxing & Gym Equipment
    { id: 19, name: 'Mako Boxing Mitts', category: 'Boxing & Gym', price: 43, image: boxingMitts },
    { id: 20, name: 'Mako Boxing Gloves', category: 'Boxing & Gym', price: 43, image: boxingGloves },
    { id: 21, name: 'Mako Gym Gloves', category: 'Boxing & Gym', price: 18, image: gymLeatherGloves },
    { id: 22, name: 'Mako Gym Leather Belt', category: 'Boxing & Gym', price: 43, image: gymLeatherBelt },
    { id: 23, name: 'Mako Gym Neoprene Belt', category: 'Boxing & Gym', price: 35, image: gymNeopreneBelt },

    // Fitness & Exercise
    { id: 24, name: 'Back Pain Helper', category: 'Fitness', price: 10, image: backPainHelper },
    { id: 25, name: 'Gymnastic Ball', category: 'Fitness', price: 33, image: gymnasticBall },
    { id: 26, name: 'Suction Sit Up', category: 'Fitness', price: 16, image: suctionSitUp },
    { id: 27, name: 'Spring Rubber Exerciser', category: 'Fitness', price: 13, image: springExerciser },
    { id: 28, name: 'Compression Vest', category: 'Fitness', price: 12, image: compressionVest },
    { id: 29, name: 'Elbow Support', category: 'Fitness', price: 9, image: cricketElbowGuard }, // Reusing elbow guard
    { id: 30, name: 'Hip Resistance Bands', category: 'Fitness', price: 7, image: hipBands },
    { id: 31, name: 'Resistance Bands', category: 'Fitness', price: 9, image: resistanceBands },

    // Swimming Gear
    { id: 32, name: 'Swimming Googles (Basic)', category: 'Swimming', price: 9, image: swimmingGoggles },
    { id: 33, name: 'Swimming Googles (Pro)', category: 'Swimming', price: 15, image: swimmingGoggles },
    { id: 34, name: 'Swimming Caps and Googles Set', category: 'Swimming', price: 12, image: swimmingCapsGoggles },

    // Other Sports & Accessories
    { id: 35, name: 'Yoga Mats', category: 'Other Sports', price: 32, image: 'https://images.unsplash.com/photo-1592432676556-269e382fa020?auto=format&fit=crop&q=80&w=800' },
    { id: 36, name: 'Volley Balls', category: 'Other Sports', price: 33, image: 'https://images.unsplash.com/photo-1593787467001-e3948223da56?auto=format&fit=crop&q=80&w=800' },
    { id: 37, name: 'Tennis Racket (Standard)', category: 'Other Sports', price: 12, image: 'https://images.unsplash.com/photo-1622279457486-62dcc4a4b1ca?auto=format&fit=crop&q=80&w=800' },
    { id: 38, name: 'Tennis Racket (Pro)', category: 'Other Sports', price: 35, image: 'https://images.unsplash.com/photo-1622279457486-62dcc4a4b1ca?auto=format&fit=crop&q=80&w=800' },
    { id: 39, name: 'Training Mat', category: 'Other Sports', price: 30, image: 'https://images.unsplash.com/photo-1592432676556-269e382fa020?auto=format&fit=crop&q=80&w=800' },

    // Accessories
    { id: 40, name: 'Wrist Sand Bags', category: 'Accessories', price: 10, image: wristSandBags },
    { id: 41, name: '0.5kg Sand Bags', category: 'Accessories', price: 12, image: sandBags05kg },
    { id: 42, name: 'Kinesiology Tape', category: 'Accessories', price: 8, image: kinesiologyTape },
    { id: 43, name: 'Glossy Dumbells 2kg', category: 'Accessories', price: 12, image: sandBags05kg }, // Fallback to sandbags or similar if dumbell img not found
    { id: 44, name: 'Assorted Football Jerseys', category: 'Accessories', price: 15, image: assortedFootballJerseys },
];

const categories = ['All', 'Cricket', 'Hockey', 'Soccer', 'Boxing & Gym', 'Fitness', 'Swimming', 'Other Sports', 'Accessories'];

const ITEMS_PER_PAGE = 12;

const Shop = ({ limit }) => {
    const [activeCategory, setActiveCategory] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);

    // When a limit is provided, we prioritize featured products then fill with others
    const getInitialProducts = () => {
        if (!limit) return products;
        const featured = products.filter(p => p.featured);
        const others = products.filter(p => !p.featured);
        return [...featured, ...others].slice(0, limit);
    };

    const displayProducts = getInitialProducts();

    const filteredProducts = activeCategory === 'All'
        ? displayProducts
        : displayProducts.filter(p => p.category === activeCategory);

    // Paginate filtered products (only when no limit is set)
    const paginatedProducts = limit
        ? filteredProducts
        : filteredProducts.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

    // Reset to first page when category changes
    const handleCategoryChange = (cat) => {
        setActiveCategory(cat);
        setCurrentPage(1);
    };

    const openWhatsApp = (name) => {
        const url = `https://wa.me/263781665264?text=Hi, I would like to order the ${encodeURIComponent(name)}`;
        window.open(url, '_blank');
    };

    return (
        <section className="shop-gallery" id="shop">
            <div className="shop-gallery__container">

                {/* Premium Header Section */}
                <div className="shop-gallery__header">
                    <div className="shop-gallery__header-content">
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            <span className="shop-gallery__eyebrow">Official Store</span>
                            <h1 className="shop-gallery__title">
                                VISION SPORTS <span className="shop-gallery__title--accent">HUB</span>
                            </h1>
                            <p className="shop-gallery__subtitle">
                                {limit ? "Top picks from our premium athletic equipment range" : "Premium athletic equipment for champions in training"}
                            </p>
                        </motion.div>

                        {/* Category Filter Pills - Only show if not limited */}
                        {!limit && (
                            <div className="shop-gallery__filters">
                                {categories.map((cat, idx) => (
                                    <motion.button
                                        key={cat}
                                        onClick={() => handleCategoryChange(cat)}
                                        className={`shop-gallery__filter-btn ${activeCategory === cat ? 'shop-gallery__filter-btn--active' : ''}`}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: idx * 0.05 }}
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.98 }}
                                    >
                                        {cat}
                                    </motion.button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Gallery Grid */}
                <motion.div layout className="shop-gallery__grid">
                    <AnimatePresence mode="popLayout">
                        {paginatedProducts.length > 0 ? (
                            paginatedProducts.map((product, idx) => (
                                <motion.article
                                    layout
                                    key={product.id}
                                    className={`shop-gallery__item ${product.featured ? 'shop-gallery__item--featured' : ''}`}
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.9 }}
                                    transition={{ duration: 0.4, delay: idx * 0.05 }}
                                >
                                    {product.featured && (
                                        <div className="shop-gallery__badge">
                                            <CheckCircle size={14} />
                                            <span>Featured</span>
                                        </div>
                                    )}

                                    {/* Image Container */}
                                    <div className="shop-gallery__image-wrapper">
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            className="shop-gallery__image"
                                            loading="lazy"
                                        />
                                        <div className="shop-gallery__overlay">
                                            <motion.button
                                                className="shop-gallery__quick-view"
                                                whileHover={{ scale: 1.1 }}
                                                whileTap={{ scale: 0.95 }}
                                            >
                                                <ExternalLink size={18} />
                                            </motion.button>
                                        </div>
                                    </div>

                                    {/* Product Info */}
                                    <div className="shop-gallery__content">
                                        <span className="shop-gallery__category">{product.category}</span>
                                        <h3 className="shop-gallery__product-name">{product.name}</h3>
                                        <div className="shop-gallery__price-row">
                                            <span className="shop-gallery__price">${product.price}</span>
                                            <span className="shop-gallery__currency">USD</span>
                                        </div>
                                    </div>

                                    {/* Action Bar */}
                                    <motion.button
                                        className="shop-gallery__cta"
                                        onClick={() => openWhatsApp(product.name)}
                                        whileHover={{ backgroundColor: '#000' }}
                                        whileTap={{ scale: 0.98 }}
                                    >
                                        <MessageCircle size={16} />
                                        <span>Order via WhatsApp</span>
                                    </motion.button>
                                </motion.article>
                            ))
                        ) : (
                            <div className="shop-gallery__empty">
                                <ShoppingBag size={48} />
                                <p>No products available in {activeCategory}</p>
                                <span>Check back soon for updates</span>
                            </div>
                        )}
                    </AnimatePresence>
                </motion.div>

                {/* Pagination - Only show on full shop page */}
                {!limit && (
                    <Pagination
                        totalItems={filteredProducts.length}
                        itemsPerPage={ITEMS_PER_PAGE}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                )}

                {/* See More Products Button - Only show if limited */}
                {limit && (
                    <div className="text-center mt-12">
                        <a href="/shop" className="btn btn-primary btn-large">
                            See More Products
                            <ExternalLink size={18} className="ml-2" />
                        </a>
                    </div>
                )}

                {/* Contact Information Bar */}
                <div className="shop-gallery__contact-bar">
                    <div className="shop-gallery__contact-icon">
                        <MessageCircle size={28} />
                    </div>
                    <div className="shop-gallery__contact-content">
                        <h4 className="shop-gallery__contact-title">Direct Sales Line</h4>
                        <p className="shop-gallery__contact-number">+263 781 665 264</p>
                        <p className="shop-gallery__contact-subtitle">Send a message to confirm availability and arrange payment</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Shop;
